module.exports = __webpack_public_path__ + "static/media/04.4f4f9cf0.png";